<template>
<div class='hostCard'>
    <div class="list_item">
        <!-- <p class="hostname">主机名称: <span></span> </p>
        <p class="hostCpu">CPU占用率:<span>{{ obj.cpu | fil_persen3 }}</span></p>
        <p class="hostMemory">内存占用率:<span>{{ obj.memory_used | fil_persen3 }}</span></p>
        <p><van-button size="small" type="default">详情</van-button></p> -->

        <div class="hostname">
            <span class="hostname_box">
                {{ obj.alias?obj.alias:obj.serverId }}
                <i class="hostname_status" :class="[obj.status==1?'status_on':'status_off']"></i>
            </span>  
            <!-- <span class="hostname_status" :style="{'color': obj.status == 1?'#57a970':'#ca4947' }">{{ obj.status == 1 ? '正常':'异常'  }}</span> -->
        </div>
        <div class="infoBox">
            <div class="infoBox_item">
                <div class="infoBox_item_title">CPU占用率</div>
                <div class="infoBox_item_value">{{ obj.cpu | fil_persen3 }}</div>
            </div>
            <div class="infoBox_item">
                <div class="infoBox_item_title">内存占用率</div>
                <div class="infoBox_item_value">{{ obj.memory_used | fil_persen3 }}</div>
            </div>
        </div>
        <div class="toolsBox">
            <van-button class="btn" size="small" type="default" @click="sub_handle_open_popup">详情</van-button>
        </div>

    </div>

</div>
</template>

<script>
export default {
    name: 'hostCard',
    props: {
        obj: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },

    components: {

    },
    data() {
        return {

        }
    },
    created: function () {

    },
    mounted: function () {

    },
    computed: {

    },
    watch: {

    },
    methods: {
        sub_handle_open_popup(){
            this.$emit('openPupop',this.obj)
        }
    },
}
</script>

<style lang="less">
.hostCard {
    background-color: #fff;
    font-size: 12px;
    margin-bottom: 8px;
    padding: 8px;
    .hostname {
        text-align: left;
        font-size: 14px;
        font-weight: 600;
        padding-bottom: 2px;
        margin-bottom: 4px;
        border-bottom: 1px solid #ebedf0;

        display: flex;
        justify-content: space-between;
        align-items: center;
        .hostname_status{
            font-size: 12px;
            
        }
    }

    .infoBox {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        border-bottom: 1px solid #ebedf0;
        .infoBox_item{
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            &:last-child {
                border-left: 1px solid #ebedf0;
            }

            .infoBox_item_title{
                width: 100%;
                text-align: left;
                height: 28px;
                line-height: 28px;
                padding-left: 6px;
                font-size: 12px;
                color: #969799;

            }
            .infoBox_item_value{
                font-size: 12px;
                width: 100%;
                text-align: center;
                height: 24px;
                line-height: 24px;
                font-size: 14px;
                font-weight: 600;

            }
        }
    }

    .toolsBox {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 4px;
        .btn{
            width: 60px;
            height: 24px;
        }
    }
}

.hostname_box{
    display: flex;
    align-items: center;
    justify-content: flex-start;

}
.hostname_status{
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 3px;
    background-color: #fff;
    margin-left: 6px;
    &.status_on{
        background-color: #52c41a;
    }
    &.status_off{
        background-color: #f5222d;
    }
}
</style>
